import styled from "styled-components";
const MonospacedText = styled.span `
  font-family: ui-monospace, monospace;
  font-weight: normal;
`;
export default MonospacedText;
